import { useContext } from 'react';

import { AuthContext } from '@/features/auth/auth-context';

/** Access the current session. Throws when used outside AuthProvider. */
export function useAuth() {
  const context = useContext(AuthContext);
  if (context === null) {
    throw new Error('useAuth must be used inside <AuthProvider>');
  }
  return context;
}
